/* eslint-disable */
// Reusable utility functions
import { HOST, PUBLIC, AUTH, API, DELAY } from "./constants";
import * as Datetime from "react-datetime";
import FileSaver from "file-saver";
import "moment/locale/tr";
import { control } from "keymaster";

export function action(type) {
  return function(payload) {
    return { type: type, payload: payload };
  };
}

export const repeted_action = (func, payload) => {
  func(payload);
  return setInterval(function() {
    func(payload);
  }, DELAY);
};

let aborter = null;

export const abortRequest = () => {
  if (aborter) aborter.abort();

}

export const request = async ({ unprotected, login, action, payload }) => {
  aborter = new AbortController();
  const signal = aborter.signal;

  let id_token = localStorage.getItem("id_token");

  if (!unprotected && !login && !id_token) {
    throw new Error({ message: "Not logged in!" });
  }

  let url = unprotected ? PUBLIC : API;
  url = login ? AUTH : url;

  let config = {
    method: "POST",
    signal,
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: `Bearer ${id_token}`
    },
    body: JSON.stringify({ action: action, payload: payload })
  };
  let data = await fetch(`${HOST}/${url}`, config);
  aborter = null;
  // console.log("data:", url, data);
  if (action === "ReportQueryDownload") {
    data = await data.blob();
    let name =
      payload.download.name + (payload.selected ? "_" + payload.selected : "");
    FileSaver.saveAs(data, `${name}.xlsx`);
  } else {
    data = await data.json();
  }
  // if (!login) {
  //   data = await data.blob();
  //   // var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
  //   FileSaver.saveAs(data, "fileName.xlsx");
  //   // console.log("data.blob:", url, data);
  // } else {
  // console.log("data.json:", url, data);
  // }
  return data;
};

/*
setTimeout(() => {
  controller.abort();
}, 200)
*/

export const dateFormat = "DD/MM/YYYY";
export const dateTimeFormat = "DD/MM/YYYY HH:mm";
export const timeFormat = "HH:mm";

export const setClientDateFormat = value => {
  if (value) {
    let res = Datetime.moment.utc(value).format(dateFormat);
    // console.log("setClientDateFormat", value, res);
    return res;
  }
  return value;
};

export const setClientDateTimeFormat = value => {
  if (value) {
    let res = Datetime.moment.utc(value).format(dateTimeFormat);
    // console.log("setClientDateTimeFormat", value, res);
    return res;
  }
  return value;
};

export const setServerDateFormat = value => {
  if (value) {
    let res = value.format();
    // console.log("setServerDateFormat", value, res);
    return res;
  }
  return value;
};

export const setYearMonthWeekFormat = value => {
  if (value) {
    return value.format("YYYY-MM-") + Math.ceil(value.date() / 7);
  }
  return value;
};

export const setClientDateFormatFromYearMonthWeek = value => {
  if (value) {
    let [year, month, week] = value.split("-");
    let day = (week - 1) * 7 + 1;
    return Datetime.moment([year, month - 1, day]).format(dateFormat);
  }
  return value;
};

export const setEndOfClientDateFormatFromYearMonthWeek = value => {
  if (value) {
    let [year, month, week] = value.split("-");
    let day = (week - 1) * 7 + 1;
    let first = Datetime.moment([year, month - 1, day]);
    let second = first
      .clone()
      .endOf("month")
      .isBefore(first.clone().add(6, "days"))
      ? first.clone().endOf("month")
      : first.clone().add(6, "days");
    return second.format(dateFormat);
  }
  return value;
};

export const flatten = list => {
  if (list && Array.isArray(list))
    return list.reduce(
      (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b),
      []
    );
  else return list;
};

export const promiseSerial = funcs =>
  funcs.reduce(
    (promise, func) =>
      promise.then(result => func().then(Array.prototype.concat.bind(result))),
    Promise.resolve([])
  );
// Sum, average, median, count, countdistinct, minimum, maximum, percentile, std.Dev Std.Dev(Pop.), Variance, Variance(Pop.)

export const isString = value =>
  typeof value === "string" || value instanceof String;
// Returns if a value is an object
export const isObject = value =>
  value && typeof value === "object" && value.constructor === Object;

export const evalOptions = (options) => {
  if (Array.isArray(options))
    return options;
  try {
    return eval(options);
  } catch (error) {
    return [];
  }
}


// WEBPACK FOOTER //
// ./src/utility.js